import type { DetectOverflowOptions } from '@floating-ui/react';
import type { CSSProperties } from 'react';

/**
 * Viewport-aware max-width for floating surfaces. Keeps the element's cap in
 * sync with Floating UI's `overflowPadding` so a consumer override on that
 * prop still leaves a matching gutter on each side.
 *
 * @param overflowPadding - Floating UI detectOverflow padding (number or side object).
 * @param maxWidth @default 360
 *
 * @example
 * getFloatingMaxWidthStyle(16)
 * // { maxWidth: 'min(360px, calc(100vw - 16px - 16px))' }
 */
export function getFloatingMaxWidthStyle(
  overflowPadding: DetectOverflowOptions['padding'] = 0,
  maxWidth = 360,
): Pick<CSSProperties, 'maxWidth'> {
  const isNumber = typeof overflowPadding === 'number';
  const left = isNumber ? overflowPadding : (overflowPadding?.left ?? 0);
  const right = isNumber ? overflowPadding : (overflowPadding?.right ?? 0);

  return {
    maxWidth: `min(${maxWidth}px, calc(100vw - ${left}px - ${right}px))`,
  };
}
